import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { dynamicSort } from '../../../common/utils/api_utils';
import * as moment from 'moment';
import cookie from 'react-cookies';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomLoader from '../../common/CustomLoader';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import history from '../../../common/history';
import { filterFieldsForTitleAndDescription, filterFieldsForImage } from './PageFormUtil';
import { getBuilderConfigURL } from '../../../common/utils/builder-config-url-util';
import { showError, showWarning } from '../../../common/utils/alert';
import { createRedirectUrl } from '../apiUtils';
import TooltipInfo from '../../../common/formElements/TooltipInfo';
import { checkPageSnapPermission } from '../../home/app_util';
import GeneralPageSetting from './GeneralPageSetting';
import MoreGeneralSetting from './MoreGeneralSetting';
import CommonPageSetting from './CommonPageSetting';
const PERMIT_ALL = 'PERMIT_ALL';

export default class PageForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  state = {
    roles: [],
    images: [],
    activeTab: '1',
    name: '',
    slug: '',
    pageClone: '',
    cloneFrom: '',
    restoreFrom: '',
    cloneSnippet: '',
    cloneSnippetSnapshot: '',
    collectionId: '',
    access: [PERMIT_ALL],
    titleTag: '',
    description: '',
    pageImage: '',
    isTitleFromCollection: false,
    isDescriptionFromCollection: false,
    isPageImageFromCollection: false,
    extraMetaTag: '',
    pageIndex: 9999,
    snapshotName: `Snapshot-${moment().format('YYYY-MMMM-DD-HH-mm-ss-SSS')}`,
    nameError: '',
    slugError: '',
    snapshotNameError: '',
    eventName: '',
    pageCloneWith: 'page_snapshot',
    pageDirection: 'ltr',
    externalScriptURL: '',
    customScript: '',
    collectionFrom: 'COLLECTION',
    externalApiId: '',
    loadCustomScriptToBuilder: true,
    rlsFilter: null,
    pageLayout: '',
  };

  componentDidMount() {
    const { page, projectId, version } = this.props;
    const header = builderSurfaceJsonContentHeader(projectId);
    const bEngineUrl = process.env.REACT_APP_BUILDER_ENGINE;

    axios
      .get(`${bEngineUrl}v${version}/items/role/`, header)
      .then((res) => this.setState({ roles: res.data }));
    axios
      .get(`${bEngineUrl}v${version}/assets/${projectId}/all-image-assests`, header)
      .then((res) => this.setState({ images: res.data }));

    if (page && Object.keys(page).length) {
      const {
        name,
        slug,
        collectionId,
        access,
        titleTag,
        description,
        pageImage,
        isTitleFromCollection,
        isDescriptionFromCollection,
        isPageImageFromCollection,
        extraMetaTag,
        pageIndex,
        eventName,
        pageDirection,
        externalScriptURL,
        customScript,
        collectionFrom,
        externalApiId,
        loadCustomScriptToBuilder,
        rlsFilter,
        pageLayoutId,
      } = page;
      this.setState({
        name,
        slug,
        collectionId,
        access,
        titleTag,
        description,
        pageImage,
        isTitleFromCollection,
        isDescriptionFromCollection,
        isPageImageFromCollection,
        extraMetaTag,
        pageIndex,
        snapshotName: `${name}-Snapshot-${moment().format('YYYY-MMMM-DD-HH-mm-ss-SSS')}`,
        eventName,
        pageDirection,
        externalScriptURL,
        customScript,
        collectionFrom: collectionFrom ? collectionFrom : 'COLLECTION',
        externalApiId,
        loadCustomScriptToBuilder,
        rlsFilter,
        pageLayout: pageLayoutId,
      });
    }
  }

  toggle = (activeTab) => this.setState({ activeTab });

  handleManageJs = () => {
    const redirectUrl = createRedirectUrl();
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { projectId, version, pageId } = this.props;
    const url = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/page-js/${pageId}?token=${token}`;
    window.location.href = url;
  };
  handleChange = (name, value) => {
    if (name === 'access') {
      const lastEntry = value ? value[value.length - 1] : null;
      if (!lastEntry || lastEntry === PERMIT_ALL) {
        this.setState({ [name]: [PERMIT_ALL] });
      } else {
        this.setState({ [name]: value.filter((val) => val !== PERMIT_ALL) });
      }
    } else if (name === 'collectionId') {
      this.setState({
        collectionId: value,
        titleTag: this.state.name,
        description: '',
        pageImage: '',
        isTitleFromCollection: false,
        isDescriptionFromCollection: false,
        isPageImageFromCollection: false,
        externalApiId: '',
        collectionFrom: 'COLLECTION',
      });
    } else if (name === 'snapshotName') {
      this.setState({ [name]: value, snapshotNameError: '' });
    } else if (name === 'pageClone') {
      this.setState({
        [name]: value,
        restoreFrom: '',
        cloneFrom: '',
        cloneSnippet: '',
        cloneSnippetSnapshot: '',
      });
    } else if (name === 'pageCloneWith') {
      this.setState({
        [name]: value,
        pageClone: '',
        restoreFrom: '',
        cloneFrom: '',
        cloneSnippet: '',
        cloneSnippetSnapshot: '',
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleNSChange = (options) => {
    this.setState(options);
  };

  handleSnapshot = () => {
    const { snapshotName } = this.state;
    if (snapshotName === '' || !snapshotName) {
      this.setState({ snapshotNameError: 'This field is required' });
      return;
    }
    let pageSnapshotValues = {
      name: snapshotName,
      projectId: this.props.projectId,
      pageId: this.props.page.uuid,
    };
    const { projectId, actions, version } = this.props;
    actions.createPageSnapshot({
      projectId,
      version,
      data: pageSnapshotValues,
    });
  };

  closeCard = () => {
    this.toggle('1');
    this.props.actions.toggleCreatePage();
    //?INFO: -> Commented code below to disable Builder Loader Screen
    // this.props.actions.hideBuilderLoader();
  };

  handleDelete = () => {
    const { page, currentOpenPageId, projectId, pages, actions, version } = this.props;
    const defaultPage = pages.find((e) => e.isDefaultPage === true);
    if (page.isDefaultPage) {
      showError(`${page.name}`, "Default page of the application. So can't be deleted.");
      return;
    }
    const preConfirm = () => {
      return actions.deletePage({ projectId, version, pageId: page.uuid });
    };
    showWarning("You won't be able to revert this.", preConfirm, 'Yes, delete it!').then(
      (result) => {
        if (result.isConfirmed) {
          this.props.actions.toggleCreatePage();
          if (page.uuid === currentOpenPageId) {
            history.push(`/editor/${version}/v/${projectId}/pages/${defaultPage.uuid}`);
          }
        }
      },
    );
  };

  handleSubmit = async () => {
    const {
      name,
      slug,
      cloneFrom,
      restoreFrom,
      cloneSnippet,
      cloneSnippetSnapshot,
      collectionId,
      access,
      titleTag,
      description,
      pageImage,
      isTitleFromCollection,
      isDescriptionFromCollection,
      isPageImageFromCollection,
      extraMetaTag,
      pageIndex,
      nameError,
      slugError,
      eventName,
      pageDirection,
      externalScriptURL,
      customScript,
      collectionFrom,
      externalApiId,
      loadCustomScriptToBuilder,
      rlsFilter,
      pageLayout,
    } = this.state;
    if (name === '' || !name) {
      this.setState({ nameError: 'This field is required' });
      return;
    }
    if (name && name.startsWith('-')) {
      this.setState({ nameError: 'Name should not start with hyphen(-)' });
      return;
    }
    if (name && name.startsWith(' ')) {
      this.setState({ nameError: 'Name should not start with space' });
      return;
    }
    if (slug === '' || !slug) {
      this.setState({ slugError: 'This field is required' });
      return;
    }
    if (slug && slug.startsWith('-')) {
      this.setState({ slugError: 'Page URL should not start with hyphen(-)' });
      return;
    }
    if (slug && slug.startsWith(' ')) {
      this.setState({ slugError: 'Page URL should not start with space' });
      return;
    }
    if (nameError || slugError) {
      return;
    }
    const { page, projectId, actions, version } = this.props;
    const { updatePage, createPage, toggleCreatePage } = actions;
    const { uuid, isDefaultPage } = page;
    const values = {
      name,
      slug,
      cloneFrom,
      restoreFrom,
      cloneSnippet,
      cloneSnippetSnapshot,
      collectionId,
      access,
      titleTag,
      description,
      pageImage,
      isTitleFromCollection,
      isDescriptionFromCollection,
      isPageImageFromCollection,
      extraMetaTag,
      pageIndex,
      eventName,
      pageDirection,
      externalScriptURL,
      customScript,
      collectionFrom,
      externalApiId,
      projectId,
      loadCustomScriptToBuilder,
      rlsFilter,
      pageLayoutId: pageLayout,
    };
    if (uuid) {
      values.isDefaultPage = isDefaultPage;
      updatePage({
        projectId,
        version,
        pageId: uuid,
        data: values,
      });
    } else {
      const { uuid } = await createPage({
        projectId,
        version,
        data: values,
      });
      toggleCreatePage();
      history.push(`/editor/${version}/v/${projectId}/pages/${uuid}`);
    }
  };

  pageCopyOptions = (value) => {
    let options = [
      { value: '', label: '- Select One -' },
      { value: 'fromExistingPages', label: `${value} from Existing Pages` },
      { value: 'fromPageSnapshots', label: `${value} from Page Snapshots` },
    ];

    return options;
  };

  snippetCopyOptions = (value) => {
    let options = [
      { value: '', label: '- Select One -' },
      { value: 'fromExistingSnippets', label: `${value} from Existing Snippets` },
      { value: 'fromSnippetSnapshots', label: `${value} from Snippet Snapshots` },
    ];
    return options;
  };

  pageOptions = () => {
    let options = [{ value: '', label: '- Select Page -' }];
    if (this.props.pages.length > 0) {
      options = options.concat(
        this.props.pages.sort(dynamicSort('name')).map((page) => {
          return { value: page.uuid, label: page.name };
        }),
      );
    }
    return options;
  };

  pageSnapshotOptions = () => {
    let options = [{ value: '', label: '- Select Page Snapshot -' }];
    const { pageSnapshots } = this.props;
    if (pageSnapshots.length > 0) {
      const sortedSnapshots = pageSnapshots.sort(dynamicSort('createdAt')).reverse();
      options = options.concat(
        sortedSnapshots.map((snapshot) => ({
          value: snapshot.uuid,
          label: snapshot.name,
        })),
      );
    }
    return options;
  };

  snippetOptions = () => {
    let options = [{ value: '', label: '- Select Snippet -' }];
    if (this.props.snippets.length > 0) {
      options = options.concat(
        this.props.snippets.sort(dynamicSort('name')).map((snippet) => {
          return { value: snippet.uuid, label: snippet.name };
        }),
      );
    }
    return options;
  };

  snippetSnapshotOptions = () => {
    let options = [{ value: '', label: '- Select Snippet -' }];
    if (this.props.snippetSnapshots.length > 0) {
      options = options.concat(
        this.props.snippetSnapshots.sort(dynamicSort('name')).map((snippetSnapshot) => {
          return { value: snippetSnapshot.uuid, label: snippetSnapshot.name };
        }),
      );
    }
    return options;
  };

  getRoleOption = () => {
    let options = [
      { value: PERMIT_ALL, label: 'Public (Anyone)' },
      { value: 'AUTHENTICATED', label: ' Secured (Only LoggedIn User)' },
    ];
    const { roles } = this.state;
    const roleOptions =
      roles.length > 0
        ? roles.sort(dynamicSort('name')).map((role, key) => {
            return { value: role.name, label: `Users with ${role.name} Role` };
          })
        : [];
    return [...options, ...roleOptions];
  };

  collectionsOptions = () => {
    const { collections } = this.props;
    let options = [{ value: '', label: 'Select a Collection' }];
    const collectionOptions =
      collections.length > 0
        ? collections.sort(dynamicSort('collectionName')).map((collection) => {
            return { value: collection.collectionName, label: collection.collectionTitle };
          })
        : [];
    return [...options, ...collectionOptions];
  };

  externalAPIOptions = () => {
    const { externalApis } = this.props;
    const { collectionId } = this.state;

    let options = [{ value: '', label: 'Select an External API' }];
    const externalApiOptions =
      externalApis.length > 0
        ? externalApis
            .filter(
              (externalAPI) =>
                [
                  'REST_API',
                  'AIRTABLE',
                  'XANO',
                  'NOTION',
                  'APP_WRITE',
                  'SUPABASE',
                  'XATA',
                  'DIRECTUS',
                ].includes(externalAPI.externalApiType) &&
                externalAPI.responseDataMapping.selectedCollectionName &&
                externalAPI.responseDataMapping.selectedCollectionName === collectionId,
            )
            .sort(dynamicSort('externalApiName'))
            .map((externalAPI) => {
              return { value: externalAPI.uuid, label: externalAPI.externalApiName };
            })
        : [];
    return [...options, ...externalApiOptions];
  };

  collectionFromOptions = () => {
    let options = [
      { value: '', label: 'Select Bind Data From' },
      { value: 'COLLECTION', label: 'Collection (Default)' },
      { value: 'EXTERNAL_API', label: 'External API' },
    ];
    return [...options];
  };

  eventOptions = () => {
    const { events } = this.props;
    let options = [{ value: '', label: 'Select a event' }];
    const eventOptions =
      events.length > 0
        ? events.map((ev) => {
            return { value: ev.eventName, label: ev.eventTitle };
          })
        : [];
    return [...options, ...eventOptions];
  };

  getImageOptions = () => {
    const { images } = this.state;
    const options =
      images.length > 0
        ? images.sort(dynamicSort('fileName')).map((image) => ({
            value: image.key,
            label: (
              <div>
                <img
                  src={`${process.env.REACT_APP_S3_URL}${image.key}`}
                  height="35px"
                  width="45px"
                />
                {'  '}
                {image.fileName}
              </div>
            ),
          }))
        : [];
    return options;
  };

  getFieldsOptions = (value) => {
    let options = [];
    if (value) {
      const { collections } = this.props;
      const selectedCollection = collections.find((e) => e.collectionName === value);
      if (!selectedCollection || selectedCollection === null) return [];
      console.log('getFieldsOptions');
      const fields = selectedCollection ? selectedCollection.fields : [];
      const utilities = selectedCollection ? selectedCollection.utilities : [];
      const filteredFileds = filterFieldsForTitleAndDescription(fields);
      console.log('fieldOptions');
      const fieldOptions = filteredFileds.sort(dynamicSort('fieldName')).map((item, key) => {
        return { value: item.fieldName, label: item.fieldTitle.en };
      });
      console.log('utilityOptions');
      const utilityOptions = utilities.sort(dynamicSort('name')).map((utility) => {
        return {
          value: utility.name,
          label: utility.name,
        };
      });
      options = [
        {
          label: 'Fields',
          options: fieldOptions,
        },
        {
          label: 'Derived Fields',
          options: utilityOptions,
        },
      ];
    }
    return options;
  };

  getImageFieldsOptions = (value) => {
    let options = [];
    if (value) {
      const { collections } = this.props;
      const selectedCollection = collections.find((e) => e.collectionName === value);
      if (!selectedCollection || selectedCollection === null) return [];
      console.log('getImageFieldsOptions');
      const fields = selectedCollection ? selectedCollection.fields : [];
      const filteredFileds = filterFieldsForImage(fields);
      options = filteredFileds.sort(dynamicSort('fieldName')).map((item, key) => {
        return { value: item.fieldName, label: item.fieldTitle.en };
      });
    }
    return options;
  };

  getPageDirectionOptions = () => {
    let options = [
      { value: 'ltr', label: 'Left to Right (Default)' },
      { value: 'rtl', label: 'Right to Left' },
    ];
    return [...options];
  };

  getRowLevelSecurityFilterOptions = () => {
    const { collections } = this.props;
    const { collectionId } = this.state;
    if (!collectionId) return [];
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionId,
    );
    if (!selectedCollection) return [];
    const { rowLevelSecurityFilter } = selectedCollection;
    const rlsOptions =
      rowLevelSecurityFilter && rowLevelSecurityFilter.length
        ? rowLevelSecurityFilter.map((filter) => ({
            value: filter.uuid,
            label: filter.name,
          }))
        : [];
    return rlsOptions;
  };

  showCloneFrom = () => {
    const { activeTab, pageClone, pageCloneWith } = this.state;
    if (!this.props.page.uuid) {
      return (
        <div className="form-group">
          <label style={{ paddingBottom: '0px' }}>Copy Content From:</label>
          <br />
          <input
            type="radio"
            name="pageCloneWith"
            checked={pageCloneWith === 'page_snapshot'}
            value="page_snapshot"
            onChange={(e) => this.handleChange(e.target.name, e.target.value)}
          />
          <label> &nbsp; Page/Snapshot (Optional)</label>
          <input
            style={{ marginLeft: '4rem' }}
            type="radio"
            name="pageCloneWith"
            checked={pageCloneWith === 'snippet'}
            value="snippet"
            onChange={(e) => this.handleChange(e.target.name, e.target.value)}
          />
          <label> &nbsp; Snippet/Segment (Optional)</label>
          {pageCloneWith === 'page_snapshot' && (
            <CustomSelect
              name="pageClone"
              isMulti={false}
              onChange={this.handleChange}
              options={this.pageCopyOptions('Copy')}
              value={pageClone}
            />
          )}
          {pageCloneWith === 'snippet' && (
            <CustomSelect
              name="pageClone"
              isMulti={false}
              onChange={this.handleChange}
              options={this.snippetCopyOptions('Copy')}
              value={pageClone}
            />
          )}
        </div>
      );
    } else if (this.props.page.uuid && activeTab === '3') {
      const options = [
        ...this.pageCopyOptions('Replace'),
        ...this.snippetCopyOptions('Replace').filter((option) => option.value !== ''),
      ];
      return (
        <div className="form-group">
          <label>Replace Page With</label>
          <small>
            ( It will replace the page content with the selected Page / Snapshot content. )
          </small>
          <CustomSelect
            name={'pageClone'}
            isMulti={false}
            onChange={this.handleChange}
            options={options}
            value={pageClone}
          />
        </div>
      );
    }
  };

  showExistingPagesOptions = () => {
    const { activeTab, pageClone, cloneFrom } = this.state;
    if (!this.props.page.uuid && pageClone === 'fromExistingPages') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneFrom'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.pageOptions()}
            value={cloneFrom}
          />
        </div>
      );
    } else if (this.props.page.uuid && pageClone === 'fromExistingPages' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneFrom'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.pageOptions()}
            value={cloneFrom}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  showPageSnapshotsOptions = () => {
    const { activeTab, pageClone, restoreFrom } = this.state;
    if (!this.props.page.uuid && pageClone === 'fromPageSnapshots') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'restoreFrom'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.pageSnapshotOptions()}
            value={restoreFrom}
          />
        </div>
      );
    } else if (this.props.page.uuid && pageClone === 'fromPageSnapshots' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'restoreFrom'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.pageSnapshotOptions()}
            value={restoreFrom}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  showExistingSnippetOptions = () => {
    const { activeTab, pageClone, cloneSnippet } = this.state;
    if (!this.props.page.uuid && pageClone === 'fromExistingSnippets') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippet'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.snippetOptions()}
            value={cloneSnippet}
          />
        </div>
      );
    } else if (this.props.page.uuid && pageClone === 'fromExistingSnippets' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippet'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.snippetOptions()}
            value={cloneSnippet}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  showSnippetSnapshotsOptions = () => {
    const { activeTab, pageClone, cloneSnippetSnapshot } = this.state;
    if (!this.props.page.uuid && pageClone === 'fromSnippetSnapshots') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippetSnapshot'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.snippetSnapshotOptions()}
            value={cloneSnippetSnapshot}
          />
        </div>
      );
    } else if (this.props.page.uuid && pageClone === 'fromSnippetSnapshots' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippetSnapshot'}
            isMulti={false}
            onChange={this.handleChange}
            options={this.snippetSnapshotOptions()}
            value={cloneSnippetSnapshot}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  loginPluginControls = () => {
    const { plugins } = this.props;
    const { access } = this.state;
    if (plugins) {
      let loginPlugin = plugins.find((el) => el.code === 'LOGIN');
      if (loginPlugin) {
        return (
          <div>
            <div className="form-group">
              <label htmlFor="access">Access To:</label>
              <CustomSelect
                key={'access'}
                name={'access'}
                isMulti={true}
                onChange={this.handleChange}
                options={this.getRoleOption()}
                value={access}
              />
            </div>
          </div>
        );
      }
    }
  };

  submitButtonText = (showLoader) => {
    if (this.props.page.uuid) {
      return (
        <span>
          <i className="wb webconnect-save-regular"></i>&nbsp;Update&nbsp;
          <CustomLoader loading={showLoader} />
        </span>
      );
    } else {
      return (
        <span>
          <i className="wb webconnect-plus"></i>&nbsp;Create&nbsp;
          <CustomLoader loading={showLoader} />
        </span>
      );
    }
  };

  render() {
    const flagDescription = `Go to the Delete Permissions in Settings and Enable it.`;
    const isAllow = checkPageSnapPermission();
    const {
      flag,
      version,
      project,
      page,
      snippets,
      pages,
      pageSnapshots,
      snippetSnapshots,
      plugins,
      collections,
      projectId,
      externalApis,
    } = this.props;
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const {
      activeTab,
      name,
      slug,
      collectionId,
      isTitleFromCollection,
      isDescriptionFromCollection,
      isPageImageFromCollection,
      titleTag,
      description,
      pageImage,
      extraMetaTag,
      pageIndex,
      snapshotName,
      nameError,
      slugError,
      snapshotNameError,
      eventName,
      pageDirection,
      externalScriptURL,
      customScript,
      loadCustomScriptToBuilder,
    } = this.state;

    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() => this.toggle('1')}
            >
              General
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '2' })}
              onClick={() => this.toggle('2')}
            >
              Settings
            </NavLink>
          </NavItem>
          {this.props.page.uuid ? (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' })}
                onClick={() => this.toggle('3')}
              >
                Advance
              </NavLink>
            </NavItem>
          ) : (
            ''
          )}
          {this.props.page.uuid ? (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '4' })}
                onClick={() => this.toggle('4')}
              >
                Custom JS
              </NavLink>
            </NavItem>
          ) : (
            ''
          )}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <GeneralPageSetting
              state={this.state}
              project={project}
              snippets={snippets}
              page={page}
              name={name}
              slug={slug}
              nameError={nameError}
              slugError={slugError}
              handleNSChange={this.handleNSChange}
              handleChange={this.handleChange}
              pages={pages}
              pageSnapshots={pageSnapshots}
              snippetSnapshots={snippetSnapshots}
              plugins={plugins}
            />
          </TabPane>
          <TabPane tabId="2">
            <MoreGeneralSetting
              state={this.state}
              isTitleFromCollection={isTitleFromCollection}
              collectionId={collectionId}
              handleChange={this.handleChange}
              titleTag={titleTag}
              collections={collections}
              description={description}
              isDescriptionFromCollection={isDescriptionFromCollection}
              isPageImageFromCollection={isPageImageFromCollection}
              pageImage={pageImage}
              pageDirection={pageDirection}
              extraMetaTag={extraMetaTag}
              projectId={projectId}
              externalApis={externalApis}
            />
          </TabPane>
          {this.props.page.uuid ? (
            <TabPane tabId="3">
              <div className="row">
                <div className="col-12">
                  {!isAllow ? (
                    <div class="col-12 mt-3">
                      To use Page Snapshots, please upgrade your plan.{' '}
                      <a
                        href={`${process.env.REACT_APP_ORGANIZATION}accounts`}
                        className="btn btn-sm btn-theme-submit"
                      >
                        <i className="wb webconnect-paper-plane-fill"></i> Upgrade
                      </a>
                    </div>
                  ) : (
                    <div className="form-group">
                      <label htmlFor="titleTag">Snapshot Name</label>
                      <input
                        type="text"
                        name="snapshotName"
                        className="form-control form-control-sm"
                        placeholder="Snapshot Name"
                        value={snapshotName}
                        onChange={(e) => this.handleChange(e.target.name, e.target.value)}
                      />
                      {snapshotNameError && <p className="text-error">{snapshotNameError}</p>}
                      <div className="row p-2">
                        <div className="col-12">
                          <div className="text-right">
                            {this.props.page.uuid && activeTab === '3' ? (
                              <button
                                type="button"
                                className="btn btn-theme-submit btn-sm"
                                disabled={this.props.showPageSnapshotCreateLoader}
                                onClick={this.handleSnapshot}
                              >
                                <i className="wb webconnect-plus"></i>&nbsp;Create Snapshot&nbsp;
                                <CustomLoader loading={this.props.showPageSnapshotCreateLoader} />
                              </button>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <CommonPageSetting
                    pages={pages}
                    page={page}
                    pageSnapshots={pageSnapshots}
                    snippets={snippets}
                    snippetSnapshots={snippetSnapshots}
                    state={this.state}
                    handleChange={this.handleChange}
                  />
                  <div className="form-group">
                    <label htmlFor="eventName">Bind Event</label>
                    <CustomSelect
                      name={'eventName'}
                      isMulti={false}
                      onChange={this.handleChange}
                      options={this.eventOptions()}
                      value={eventName}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pageIndex">Page Index</label>
                    <input
                      type="number"
                      name="pageIndex"
                      className="form-control form-control-sm"
                      value={pageIndex}
                      onChange={(e) => this.handleChange(e.target.name, e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPane>
          ) : (
            ''
          )}
          {this.props.page.uuid ? (
            <TabPane tabId="4">
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="externalScriptURL">Script URL(s)</label>
                    <small>
                      ( Add external script URL(s) here, enter multiple scripts separated by comma '
                      , ' )
                    </small>
                    <textarea
                      type="text"
                      name="externalScriptURL"
                      className="form-control"
                      autoComplete="off"
                      rows="2"
                      value={externalScriptURL}
                      onChange={(e) => this.handleChange(e.target.name, e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <label for="customScript">JavaScript Code</label>
                        <small>( Add custom JavaScript code here )</small>
                      </div>
                      <button class="btn btn-theme-submit btn-xs m-1" onClick={this.handleManageJs}>
                        <i className="wb webconnect-pencil"></i>&nbsp; Custom JS Editor
                      </button>
                    </div>
                    <textarea
                      type="text"
                      name="customScript"
                      className="form-control"
                      autoComplete="off"
                      rows="10"
                      value={customScript}
                      onChange={(e) => this.handleChange(e.target.name, e.target.value)}
                    />
                  </div>

                  {/* <div className="form-group">
                    <input
                      type="checkbox"
                      name="loadCustomScriptToBuilder"
                      onChange={e => this.handleChange(e.target.name, e.target.checked)}
                      checked={loadCustomScriptToBuilder}
                    />
                    <label htmlFor="loadCustomScriptToBuilder">
                      &nbsp;Load Custom JavaScript To Builder Canvas
                    </label>
                  </div> */}
                </div>
              </div>
            </TabPane>
          ) : (
            ''
          )}
          <div className="row p-2">
            <div className="col-12">
              <div className="text-right">
                <button
                  type="button"
                  className="btn btn-theme-cancel btn-sm"
                  onClick={this.closeCard}
                >
                  <span>
                    <i className="wb webconnect-times"></i>&nbsp;Close
                  </span>
                </button>
                &nbsp;
                {this.props.page.uuid && (
                  <button
                    type="button"
                    className="btn btn-theme-delete btn-sm"
                    disabled={this.props.showPageDeleteLoader}
                    onClick={flag ? this.handleDelete : undefined}
                    style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
                  >
                    <i className="wb webconnect-trash-regular"></i>&nbsp;Delete&nbsp;
                    {flag ? null : (
                      <TooltipInfo
                        title={flagDescription}
                        headerText={`Permission Disabled!`}
                        showHeader={true}
                        showArrow={true}
                      />
                    )}
                    <CustomLoader loading={this.props.showPageDeleteLoader} />
                  </button>
                )}
                &nbsp;
                <button
                  type="submit"
                  className="btn btn-theme-submit btn-sm"
                  disabled={this.props.showPageCreateUpdateLoader}
                  onClick={this.handleSubmit}
                >
                  {this.submitButtonText(this.props.showPageCreateUpdateLoader)}
                </button>
              </div>
            </div>
          </div>
        </TabContent>
      </div>
    );
  }
}
